import { Box, Button, List, Skeleton } from '@factorialco/deprecated-design-system'
import { FinanceGetCustomDimensionSettingsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import Loading from 'modules/finance/components/Loading'

interface Props {}

const ListSkeleton = () => (
  <Box gap="s12" padding="s12">
    <Skeleton height="s64" width="s400" />
    <Skeleton height="s64" />
    <Skeleton height="s64" />
  </Box>
)

const DimensionList = ({}: Props) => {
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()

  const { data, error } = useQuery(FinanceGetCustomDimensionSettingsDocument, {
    variables: {
      companyId: company.id,
    },
  })

  const handleGoToDimension = (name: string) => {
    track(trackingEvents.accounting.dimensionsGoToDimension, {
      name,
    })
  }

  return (
    <Loading loading={!data && !error} skeleton={<ListSkeleton />}>
      {data?.finance.customDimensionsConnection.nodes.map((dimension) => (
        <List.Item key={dimension.id}>
          <Box style={{ wordBreak: 'break-word' }}>
            <List.Title ellipsis>{dimension.name}</List.Title>
            <List.Description>
              {i18n.t('finance.settings.dimensions.active', {
                values: dimension.customdimensionvaluesConnection.totalCount,
              })}
            </List.Description>
          </Box>
          <Box>
            <Button.Router
              to={navigation.settings.finance.dimensions.dimension.fullPath({ id: dimension.id })}
              onClick={() => handleGoToDimension(dimension.name)}
              type="secondary"
              iconName="arrow-right"
            />
          </Box>
        </List.Item>
      ))}
    </Loading>
  )
}

export default DimensionList
